export const QA_NAME_BUDGET_PLAN_ACTION_BUTTON =
  'requestProfileBudgetPlanActionButton'
